import { makeStyles } from "@mui/styles";
import { Box } from "@mui/material";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import QuotesBg from "../../../assets/Inspiration_quote_bg.svg";
import { useState } from "react";
const useStyle = makeStyles((theme) => ({
  header: {
    color: "white",
    fontWeight: theme.typography.fontWeightLight,
    letterSpacing: "0.05em",
  },
  quote: {
    color: "white",
    fontWeight: 600,
    letterSpacing: "0",
  },
  author: {
    color: "white",
    fontWeight: theme.typography.fontWeightLight,
    letterSpacing: "0.05em",
  },
}));

export const InspirationQuoteCard = () => {
  const classes = useStyle();
  const [quote] = useState("If you put your mind to it, you can accomplish anything");
  const [author] = useState("Marty McFly");
  // useEffect(() => {
  //   const getQuote = async () => {
  //     try {
  //       const response = await axios.get("/get-quote");
  //       let quote = response.data;
  //       setQuote(
  //         quote.quote ?? "If you put your mind to it, you can accomplish anything"
  //       );
  //       setAuthor(quote.author ?? "Marty McFly");
  //     } catch (e) {
  //       throw e;
  //     }
  //   };
  //   getQuote();
  // }, []);

  return (
    <Card
      sx={{
        border: "none",
        backgroundImage: `url(${QuotesBg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        padding: "2rem 2rem 2rem 2rem",
      }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "left",
        }}>
        <Typography
          sx={{ mb: 1.5 }}
          gutterBottom
          variant="body1"
          className={classes.header}>
          CLASS INSPIRATION
        </Typography>
        <Typography
          sx={{ mb: 1.5 }}
          variant="h5"
          component="div"
          className={classes.quote}>
          {quote}
        </Typography>
        <Typography
          sx={{ textAlign: "left", mt: "1rem;" }}
          variant="body2"
          className={classes.author}>
          - {author.toUpperCase()}
        </Typography>
      </Box>
    </Card>
  );
};
